module.exports = class ReactionHelper

  groupReactions: (reactions) ->
    if !Array.isArray(reactions)
      return []

    emojiExtension = {}
    reduced = reactions.reduce((acc, curr) ->
      emoji = curr.emoji.native
      emojiExtension["#{emoji}"] = curr
      acc["#{emoji}"] = acc[emoji] || 0
      acc["#{emoji}"]++
      return acc
    , {})
    return Object.getOwnPropertyNames(reduced).map((prop) => ({
      emoji: prop
      shortName: emojiExtension[prop].emoji.shortName
      count: reduced[prop]
    }))



// WEBPACK FOOTER //
// ./app/scripts/lib/reaction-helper.coffee